import { SpinnerLoader, Typography } from 'shared/ui'
import { UiAudioCard } from 'widgets/MessageFormFields/RinglessMessageField/ui/UiAudioCard/UiAudioCard'
import styles from './styles.module.scss'

export const InitializingAudio = () => {
  return (
    <UiAudioCard
      headerLeft={
        <Typography
          ariaLabel={'title'}
          className={styles.title}
          tag={'div'}
          variant={'body-md-medium'}
        >
          Please wait
        </Typography>
      }
      headerRight={null}
      content={
        <div className={styles.card}>
          <SpinnerLoader ariaLabel={'UploadingAudio'} size={15} />
          <Typography ariaLabel={'uploading'} color={'tertiary'} variant={'body-md-regular'}>
            Initializing...
          </Typography>
        </div>
      }
    />
  )
}
